import * as React from "react";
import InputText from "../InputText/InputText";
import { Form, Input, InputOnChangeData } from "semantic-ui-react";

export type TextFieldProps = {
  id: string;
  label: string;
  value: string | null;
  disabled?: boolean;
  isError?: boolean;
  errorMessage?: string;
  isSingleLine?: boolean;
  readonly?: boolean;
  onChange: (value: string) => void;
};

function TextField({
  id,
  label,
  value,
  readonly= false,
  disabled = false,
  isError = false,
  errorMessage = "",
  isSingleLine = false,
  onChange
}: TextFieldProps): JSX.Element {
  return !isSingleLine ? (
    <>
      <InputText
        id={id}
        name={label}
        //I clean it from extra boolean cast
        value={value ? value : ""}
        disabled={disabled}
        readOnly={readonly}
        isError={isError}
        handleInputChanged={changedValue => {
          onChange(changedValue);
        }}
      />
      {(isError && errorMessage) && <p className="errorMessageMargin">{errorMessage}</p>}
    </>
  ) : (
    <>
      <Form.Field
        id={id}
        className="edit-number-property"
        control={Input}
        label={label}
        type="text"
        error={isError}
        value={value}
        disabled={disabled}
        readOnly={readonly}
        // eslint-disable-next-line
        onChange={({}, data: InputOnChangeData) => {
          onChange(String(data.value));
        }}
      />
      {(isError && errorMessage) && <p className="errorMessageMargin">{errorMessage}</p>}
    </>
  );
}

export default TextField;
